import { render } from "./product-add-actions.vue?vue&type=template&id=5da0a6c9"
import script from "./product-add-actions.vue?vue&type=script&lang=js"
export * from "./product-add-actions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__